<div class="pricy-notice">
  <span>Aviso de Privacidade da S&P Global Market Intelligence</span>
</div>
<div class="col-xs-12 privacy-content">
  <div>
    <p>
      <strong>
        Inclusão dos Dados de Contato de Sua Empresa nos Recursos da S&P Global
        Market Intelligence para Profissionais dos Mercados de Capitais
      </strong>
    </p>
  </div>

  <div>
    <p>
      A S&P Global Market Intelligence, uma divisão da S&P Global, coletou
      informações de contato de sua empresa, tais como (seu nome, cargo e/ou
      função, número de telefone comercial, endereço postal profissional e
      endereço de correio eletrônico profissional), bem como outras informações
      descritas na seção “Quais Informações Coletamos e Tratamos”
      deste aviso de privacidade (“<strong>Informações</strong>”). A S&P Global Market Intelligence coleta Informações
      de diversas
      fontes, incluindo de suas contrapartes na comunidade global dos mercados
      de capitais, bem como diretamente de você e/ou conforme descrito na seção abaixo “<strong>Como Coletamos Suas Informações de Contato
        Profissional</strong>”
      , para inclusão em nosso recurso abrangente de contatos na comunidade
      global dos mercados de capitais. A S&P Global Market Intelligence é a controladora do tratamento de suas
      Informações, o que significa
      que decide como tratá-las e assume determinadas responsabilidades em relação a
      elas. Os dados da S&P Global Market
      Intelligence são amplamente utilizados para facilitar a comunicação
      empresarial relevante e a troca de informações entre profissionais dos
      mercados de capitais, apoiando os Participantes dos Mercados de Capitais (conforme definido abaixo)
      em seus esforços de conformidade regulatória. Solicitamos a leitura atenta
      deste Aviso de Privacidade para compreender como a S&P Global Market
      Intelligence trata suas Informações e como você poderá exercer seus
      direitos em relação ao tratamento de suas Informações.
    </p>
  </div>

  <div>
    <p>
      Para garantir a exatidão de seus dados, a S&P Global Market Intelligence
      permite-lhe rever as Informações tratadas. Para retificar seus dados,
      optar pela eliminação ou, se preferir que a S&P Global Market Intelligence
      não trate suas Informações conforme descrito neste aviso de privacidade,
      siga as instruções na seção “<strong>Seus Direitos</strong>” abaixo.
    </p>
  </div>

  <h3 class="privacy-h3">Sobre os Dados da S&P Global Market Intelligence</h3>

  <div>
    <p>
      Os dados da S&P Global Market Intelligence auxiliam investidores e
      participantes dos mercados de capitais a trabalhar com mais eficiência,
      identificando os destinatários adequados para receber informações sobre
      oportunidades financeiras. Os profissionais dos mercados de capitais se
      beneficiam ao ter suas Informações convenientemente disponíveis em nossos
      recursos.
    </p>
  </div>

  <h3 class="privacy-h3">Sobre Nós</h3>

  <div>
    <p>
      A S&P Global Inc. e suas subsidiárias são denominadas coletivamente neste
      Aviso de Privacidade como “<strong>S&P Global Market Intelligence</strong>”, “<strong>nós</strong>” ou “<strong>nosso</strong>”.
    </p>
  </div>

  <div>
    <p>
      A S&P Global (NYSE: <strong>SPGI</strong>) fornece inteligência essencial,
      capacitando governos, empresas e indivíduos com os dados, a expertise e a
      tecnologia adequados para tomadas de decisão assertivas. Apoiamos nossos
      clientes na avaliação de novos investimentos, no acompanhamento da
      transição energética e nas questões ESG ao longo das cadeias de
      suprimentos, abrindo novas oportunidades, superando desafios e
      impulsionando o progresso global.
    </p>
  </div>

  <div>
    <p>
      Somos procurados por muitas das principais organizações do mundo para
      fornecer classificações de crédito, indicadores, análises e soluções de soluções de
      fluxo nos mercados globais de capitais, commodities e automotivos. Com
      cada uma de nossas ofertas, ajudamos as organizações líderes globais a
      planejar o futuro, hoje.
    </p>
  </div>

  <div>
    <p>
      A S&P Global Market Intelligence é uma divisão corporativa da S&P Global.
      A S&P Global também possui outras divisões, tais como: S&P Global
      Commodity Insights, S&P Global Mobility e S&P Global Ratings, cada uma das
      quais fornece produtos e serviços distintos. A S&P Global mantém as
      atividades de suas divisões comerciais separadas entre si, a fim de
      preservar a independência e a objetividade de suas atividades, em
      conformidade com a Política de Independência e Objetividade das Divisões
      da S&P Global. A S&P Global Market Intelligence ("SPGMI") produz informações que
      incluem avaliações e índices de preços. A S&P Global mantém uma clara
      segregação estrutural e operacional entre suas atividades de avaliação de
      preços e as demais atividades realizadas pela S&P Global Market
      Intelligence e outras divisões corporativas da S&P Global, a fim de
      preservar a qualidade, independência e integridade de suas avaliações de
      preços e índices, garantindo que estejam livres de qualquer conflito de
      interesses, real ou aparente.
    </p>
  </div>

  <h3 class="privacy-h3">
    Como Coletamos Suas Informações de Contato Profissional
  </h3>

  <div>
    <p>
      As Informações contidas nos recursos da S&P Global Market Intelligence
      referem-se a indivíduos e empresas da comunidade global dos mercados de
      capitais (“<strong>Participantes dos Mercados de Capitais</strong>”). As
      Informações podem ser coletadas de forma independente pelo departamento de
      pesquisa da S&P Global Market Intelligence. Geralmente, isso ocorre a
      partir de fontes públicas (incluindo conteúdo disponibilizado publicamente
      em sites de redes profissionais, outros sites, registros regulatórios
      públicos e fontes de notícias públicas, ou inferidas através do formato
      padrão de e-mail corporativo e verificadas por meio de um processo de
      garantia de qualidade). Também obtemos e podemos validar Informações a
      partir do site de sua empresa, de conversas com você ou com outros
      profissionais de sua organização e/ou com suas contrapartes na comunidade
      global dos mercados de capitais. A coleta, garantia de qualidade e/ou
      criação de conteúdo pode ser realizada ou processada com a assistência de
      tecnologias de inteligência artificial, que são revisadas e
      supervisionadas por profissionais da S&P Global Market Intelligence. Ao utilizar fontes públicas, a S&P Global Market
      Intelligence tem o cuidado de coletar apenas as Informações necessárias
      para as finalidades descritas neste Aviso de Privacidade e de rever e
      verificar todas as Informações que coletamos dessas fontes.
    </p>
  </div>

  <h3 class="privacy-h3">Quais Informações Coletamos e Tratamos</h3>

  <div>
    <p>
      Podemos coletar e tratar qualquer um ou todos os seguintes tipos de
      Informações sobre você: nome, idade, gênero, vínculo empresarial, número
      de telefone (números de telefone gerais ou diretos de negócios, fax e/ou
      números de telefone celular), endereço de e-mail profissional, cargo e/ou
      função, endereço do escritório, histórico profissional e educacional,
      afiliações profissionais, investimentos e participações nos mercados
      públicos e privados, remuneração, participações e atividades de insiders,
      membros de conselhos e comitês profissionais, bem como links para redes
      sociais e sites de networking profissional. Para visualizar as Informações
      que temos sobre você, por favor, siga as instruções na seção “Seus
      Direitos” abaixo.
    </p>
  </div>

  <h3 class="privacy-h3">Como Utilizamos Suas Informações</h3>

  <h3 class="privacy-h3">Recurso de Participantes nos Mercados de Capitais</h3>

  <div>
    <p>
      Tratamos as Informações para compilar um recurso abrangente de
      Participantes dos Mercados de Capitais e para comercializar esses dados a
      clientes, incluindo clientes fora do Espaço Econômico Europeu ("EEE") e do
      Reino Unido ("RU"), que licenciam produtos e serviços da S&P Global Market
      Intelligence, incluindo os próprios dados. O principal objetivo dos dados
      é fornecer aos clientes da S&P Global Market Intelligence um recurso
      abrangente de Participantes dos Mercados de Capitais, que possam utilizar
      para facilitar a comunicação e o intercâmbio de informações relevantes
      entre empresas com esses contatos (ver “Partilha de Informações”) e para a
      comercialização de produtos e serviços da S&P Global Market Intelligence,
      conforme permitido pela legislação aplicável (ver "Marketing" abaixo).
    </p>
  </div>

  <div>
    <p>
      Também podemos utilizar suas Informações para contatá-lo a fim de
      verificar os dados que coletamos sobre você a partir de fontes públicas e
      para obter informações fornecidas por você em nome de nossos clientes,
      tais como certificados de conformidade relacionados a transações nos
      mercados de capitais em que você participa em nome de sua empresa.
    </p>
  </div>

  <h3 class="privacy-h3">Marketing</h3>

  <div>
    <p>
      Sempre que permitido por lei, a S&P Global Market Intelligence pode utilizar suas
      Informações para contatá-lo acerca de nossos produtos e serviços, bem como para lhe
      enviar notícias sobre produtos e outras informações que consideramos relevantes para
      sua organização e/ou empresa. Você poderá optar por não receber estas comunicações de
      marketing direto seguindo as instruções na seção "Seus Direitos" abaixo.
    </p>
  </div>

  <div>
    <p>
      Tenha em atenção que, caso opte por não receber comunicações de marketing direto através
      da opção abaixo, ainda poderemos necessitar de tratar algumas Informações limitadas para
      garantir que não volte a receber comunicações de marketing de nossa parte.
      Podemos enviar-lhe comunicações administrativas essenciais no contexto da utilização contínua de nossos produtos e
      serviços.
    </p>
  </div>

  <h3 class="privacy-h3">Compartilhamento de Informações</h3>

  <div>
    <p>
      Conforme descrito acima, podemos compartilhar ou licenciar seus dados
      internamente em nosso grupo de empresas afiliadas e com terceiros não
      afiliados (como profissionais dos mercados de capitais, incluindo bancos,
      empresas públicas e privadas, investidores institucionais e individuais, e
      empresas de pesquisa, gestão de ativos e gestão de patrimônio), para que
      possam utilizar essas Informações com o objetivo limitado de contatá-lo
      sobre oportunidades nos mercados de capitais relevantes para seu negócio.
      Faremos nossos melhores esforços comerciais para estabelecer acordos que
      exijam que tais terceiros limitem o uso de suas Informações àqueles que
      sejam compatíveis com a legislação aplicável e com este Aviso de
      Privacidade, a menos que obtenham seu consentimento para utilizar suas
      Informações para qualquer outra finalidade, caso em que este Aviso de
      Privacidade não se aplica ao uso de suas Informações por essa organização.
      Aconselhamos o usuário a consultar os avisos de privacidade fornecidos por
      esses terceiros para obter detalhes sobre a forma como tratam suas
      Informações.
    </p>
  </div>

  <div>
    <p>
      Deixaremos de fornecer seus dados a terceiros para os fins acima descritos
      assim que nos informar sobre suas preferências de eliminação, seguindo as
      instruções na seção "<strong>Seus Direitos</strong>" abaixo. Você também pode solicitar a
      qualquer terceiro de quem receba comunicação que pare de tratar suas
      Informações e que o exclua de suas comunicações de marketing ou de
      qualquer outra comunicação.
    </p>
  </div>

  <div>
    <p>
      O armazenamento de seus dados em nossos sistemas, bem como o
      compartilhamento de suas Informações com, ou a concessão de licenças de
      suas Informações para, terceiros, conforme descrito acima, pode envolver a
      transferência internacional de suas Informações para fora do Brasil.
      Quando transferimos suas Informações para fora do Brasil, fazemo-lo de
      acordo com os termos deste Aviso de Privacidade e da legislação de
      proteção de dados aplicável.
    </p>
  </div>

  <h3 class="privacy-h3">Bases Legais para o Tratamento</h3>

  <div>
    <p>
      Quando relevante, a S&P Global Market Intelligence baseia-se no fundamento
      dos interesses legítimos para o tratamento das Informações. A S&P Global
      Market Intelligence considera o tratamento de suas Informações necessário
      para os fins de seus interesses legítimos em fornecer seus dados aos
      clientes. Conforme descrito acima, a S&P Global Market Intelligence
      coletou ou adquiriu suas Informações para incluí-las em seu repositório de
      contatos na comunidade global de mercados de capitais.
    </p>
  </div>

  <h3 class="privacy-h3">Retenção</h3>
  <div style="white-space: pre-line">
    <p>
      Retemos suas Informações pelo período não superior ao necessário para as
      finalidades estabelecidas neste Aviso de Privacidade. Ao determinar os
      períodos de retenção de dados, levamos em consideração as leis locais, as
      obrigações contratuais, nossas necessidades comerciais, bem como suas
      expectativas e requisitos. Quando já não precisarmos de suas Informações,
      anonimizamo-las ou eliminamo-las de forma segura.
    </p>
  </div>

  <h3 class="privacy-h3">Seus Direitos</h3>

  <div style="white-space: pre-line">
    <p>
      Nos termos da legislação aplicável, você pode ter o direito de:
    </p>
    <ul>
      <li>Confirmar a existência de tratamento de seus dados pessoais;</li>
      <li>Acessar seus dados pessoais;</li>
      <li>Solicitar a correção de dados pessoais incompletos, inexatos ou desatualizados;</li>
      <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em
        desconformidade com os requisitos legais;</li>
      <li>Solicitar a portabilidade dos dados pessoais a outro fornecedor de serviços ou produtos;</li>
      <li>Solicitar a eliminação dos dados pessoais tratados com o seu consentimento;</li>
      <li>Solicitar informações sobre as entidades públicas e privadas com as quais partilhámos dados;</li>
      <li>Solicitar informações sobre a possibilidade de revogar o consentimento, bem como as implicações dessa
        revogação;</li>
      <li>Solicitar a revisão de decisões tomadas unicamente com base em tratamento automatizado de dados pessoais que
        afetem seus interesses;</li>
      <li>Revogar o consentimento.</li>
    </ul>
  </div>

  <div>
    <p>
      Se desejar exercer seus direitos, você ou um agente autorizado pode enviar
      um pedido por escrito para
      <a href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a>.
    </p>
  </div>

  <div>
    <p>
      Investigaremos e tentaremos resolver quaisquer reclamações ou litígios que
      recebermos relativamente ao tratamento de suas Informações, de acordo com
      a legislação aplicável. Na medida em que suas Informações são regidas e
      protegidas pelas leis brasileiras de proteção de dados, e caso não esteja
      satisfeito com a resolução de qualquer reclamação, poderá apresentar uma
      reclamação à Autoridade Nacional de Proteção de Dados (ANPD) do Brasil,
      através de seus canais oficiais.
    </p>
  </div>

  <h3 class="privacy-h3">Como Nos Contatar</h3>

  <div style="white-space: pre-line">
    <p>
      Suas perguntas, comentários e feedback são muito importantes para nós.
      Para questões ou dúvidas relacionadas à privacidade, ou para contatar
      nosso Encarregado pelo Tratamento de Dados Pessoais (DPO), entre em
      contato conosco através do e-mail
      <a href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a>.
    </p>
  </div>

  <div style="white-space: pre-line">
    <p>
      Para informações sobre os princípios gerais que seguimos na gestão de
      informações pessoais que coletamos para fins diferentes dos aqui
      indicados, por favor, visite:
      <a target="_blank" href="https://www.spglobal.com/en/privacy/privacy-policy-english">Política Global de
        Privacidade Corporativa</a>.
    </p>
  </div>
  <p>
    Encarregado de Proteção de Dados<br>
    Ana Lacativa<br>
    Rua do Passeio 38/40<br>
    Sala 1303 - Torre 2<br>
    Rio de Janeiro<br>
    Brasil
  </p>

  <p>Atualizado em 1º de Março de 2025.</p>
</div>